interface EditIconProps {
  className?: string;
}

export function EditIcon({ className = 'w-6 h-6' }: EditIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.1106 4.19824H9.5305C5.58014 4.19824 4 5.77839 4 9.72874V14.4692C4 18.4195 5.58014 19.9997 9.5305 19.9997H14.2709C18.2213 19.9997 19.8014 18.4195 19.8014 14.4692V12.889"
        stroke="#565858"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0926 5.00436L8.86682 11.2301C8.6298 11.4671 8.39278 11.9333 8.34538 12.273L8.00565 14.6511C7.87923 15.5123 8.48759 16.1128 9.34877 15.9943L11.7269 15.6545C12.0587 15.6071 12.5249 15.3701 12.7698 15.1331L18.9955 8.90732C20.07 7.83282 20.5757 6.5845 18.9955 5.00436C17.4154 3.42422 16.1671 3.92986 15.0926 5.00436Z"
        stroke="#565858"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1997 5.89648C14.7291 7.78476 16.2065 9.26219 18.1027 9.79944"
        stroke="#565858"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
